
import AppNav from 'components/AppNav'
import Cover from 'components/Cover'
import Footer from 'components/Footer'

const Layout = ({ children }) => (
  <div>
    <Cover src='https://imgur.com/4pHTxLk.png'/>
    <AppNav />
      { children }
    <Footer/>
  </div>
)
export default Layout